import type { MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryIcon from '@mui/icons-material/History';
import { useAbility } from '../auth/abilityContext';

/**
 * The "Verlauf" clock a ROW offers — a Team, a Projekt-Gruppe, a Planum or
 * Profil under its Befund, a Medium in the viewer's toolbar.
 *
 * The grids reach the same thing through `useGridRowActions().history()`, which
 * has to hand the grid's actions cell a `GridActionsCellItem`. This is that
 * button for everywhere else, and the two carry the same right: a version list
 * is `access RecordHistory`.
 *
 * Rendering nothing rather than a disabled button: a greyed clock on every row
 * says only that something is being withheld.
 */
export default function HistoryIconButton({
    onClick,
    edge
}: {
    /** Takes the event so a row can stop the click reaching its own handler. */
    onClick: (event: MouseEvent<HTMLElement>) => void;
    /** 'end' inside a list item's `secondaryAction`, to pull it flush. */
    edge?: 'end';
}) {
    const intl = useIntl();
    const ability = useAbility();
    if (!ability.can('access', 'RecordHistory')) {
        return null;
    }
    const label = intl.formatMessage({ id: 'common.history' });
    return (
        <Tooltip title={label}>
            <IconButton
                size="small"
                edge={edge}
                aria-label={label}
                onClick={onClick}
            >
                <HistoryIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
}
